<template>
    <div class="uc-wrap">
        <section class="uc-download">
                        
            <div class="filterImgTips">
                Please select model number
            </div>
            <ul class="filterImg">
                <li v-for="(item,index) in list" :key="index" @click="btnChooseImg(index)" :class="item.checked?'on':''">
                    <img :src="item.image" alt="" class="uc-icon50">
                </li>
            </ul>
            <h2>Selected model: <b class="uc-orange">{{list.find(item=>item.checked).model}}</b></h2>
            <div class="uc-content">
                <div v-for="(item,index) in list" :key="index">
                    <div class="table" v-if="item.checked">
                        <table>
                            <tr>
                                <th>Desc</th>
                                <th>Type</th>
                                <th>OS</th>
                                <!-- <th>Version</th> -->
                                <th>Operation</th>
                            </tr>
                            <tr v-for="(item2,index2) in item.detail" :key="index2">
                                <td><a :href="item2.file" target="_blank" :class="item2.type=='Driver'?(item2.os=='Mac'?'icon-ios':(item2.os=='Linux'?'icon-linux':'icon-windows')):'icon-file'">{{item2.desc}}</a></td>
                                <td>{{item2.type}}</td>
                                <td>{{item2.os}}</td>
                                <!-- <td>{{item2.version}}</td> -->
                                <td><a :href="item2.file" target="_blank" class="uc-btn orange"><img src="@/assets/images/icon-download-white.png" alt="" class="uc-icon16">Download</a></td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
export default {
    name: 'home',
    data() {
        return {
            model: null,
            detail: null,
            list: [
            {
                model: 'SK41',
                image: require('@/assets/images/N41.png'),
                checked: true,
                detail: [
                    { type: 'Label Editor', os: 'Windows', version: 'V1.01.06', file: '/download/SK41/HPRT_Label_DesignerV1.01.06.zip', desc: 'Label Editor for SK41' },
                    { type: 'Utility', os: 'Windows', version: 'V1.0.0.0', file: '/download/SK41/HPRTUtilityForLabel_CrossBorderEBussiness V1.0.0.0.zip', desc: 'Windows （Desktop Type）Utility for SK41' },
                    { type: 'Driver', os: 'Windows', version: 'v2.7.2.4', file: '/download/SK41/HPRT_SK41_Label_Printer_Windows_Driver_v2.7.2.4.zip', desc: 'Windows Driver for SK41' },
                    // { type: 'Driver', os: 'Mac', version: 'v1.3.1', file: '/download/SK41/hprt-sk41-tspl-printer-mac-driver-v1.3.1.zip', desc: 'Mac Driver for SK41' },
                    // { type: 'Driver', os: 'Linux', version: 'v1.4.0', file: '/download/SK41/HPRT_SK41_label_printer_linux_driver_v1.4.0.zip', desc: 'Linux Driver for SK41' },
                    { type: 'Manual', os: 'All System', version: 'Rev.1.0', file: '/download/SK41/HPRT_SK41_User_Manual_Rev.1.0.pdf', desc: 'User Manual for SK41' },
                    { type: 'Manual', os: 'All System', version: 'Rev.1.0', file: '/download/SK41/HPRT_SK41_Quick_Start_Guick_Rev.1.0.pdf', desc: 'Quick Start Guide Manual for SK41' },
                ],
            },
            {
                model: 'MT800',
                image: require('@/assets/images/MT800.jpg'),
                checked: false,
                detail: [
                    { type: 'Manual', os: '-', version: 'Rev.2.0', file: '/download/MT800/HPRT_MT800_User_Manual_Rev.2.0.zip', desc: 'User Manual for MT800' },
                ],
            },
            {
                model: 'MT-53',
                image: require('@/assets/images/MT-53.jpg'),
                checked: false,
                detail: [
                    { type: 'Manual', os: '-', version: 'Rev.1.1', file: '/download/MT-53/HPRT_MT53_Quick_Start_Guide_Rev.1.1.zip', desc: 'Qiuck Start Manual for MT-53' },
                ],
            },
        //             {
        //                 model: 'CP4000',
        //                 image: require('@/assets/images/N41.jpg'),
        //                 checked: false,
        //                 detail: [
        //                     { type: 'Label Editor', os: 'OS', version: 'sssss', file: 'dddd', desc: 'CP4000' },
        //                     { type: 'Label Editor', os: 'OS', version: 'sssss', file: 'dddd', desc: 'ssss' },
        //                     { type: 'Label Editor', os: 'OS', version: 'sssss', file: 'dddd', desc: 'ssss' },
        //                     { type: 'Label Editor', os: 'OS', version: 'sssss', file: 'dddd', desc: 'ssss' },
        //                     { type: 'Label Editor', os: 'OS', version: 'sssss', file: 'dddd', desc: 'ssss' },
        //                     { type: 'Label Editor', os: 'OS', version: 'sssss', file: 'dddd', desc: 'ssss' },
        //                     { type: 'Label Editor', os: 'OS', version: 'sssss', file: 'dddd', desc: 'ssss' },
        //                     { type: 'Label Editor', os: 'OS', version: 'sssss', file: 'dddd', desc: 'ssss' },
        //                     { type: 'Label Editor', os: 'OS', version: 'sssss', file: 'dddd', desc: 'ssss' },
        //     ],
        // },
        //             {
        //                 model: 'Q2',
        //                 image: require('@/assets/images/N41.jpg'),
        //                 checked: false,
        //                 detail: [
        //                     { type: 'Label Editor', os: 'OS', version: 'sssss', file: 'dddd', desc: 'Q2' },
        //                     { type: 'Label Editor', os: 'OS', version: 'sssss', file: 'dddd', desc: 'ssss' },
        //                     { type: 'Label Editor', os: 'OS', version: 'sssss', file: 'dddd', desc: 'ssss' },
        //                     { type: 'Label Editor', os: 'OS', version: 'sssss', file: 'dddd', desc: 'ssss' },
        //                     { type: 'Label Editor', os: 'OS', version: 'sssss', file: 'dddd', desc: 'ssss' },
        //                     { type: 'Label Editor', os: 'OS', version: 'sssss', file: 'dddd', desc: 'ssss' },
        //                     { type: 'Label Editor', os: 'OS', version: 'sssss', file: 'dddd', desc: 'ssss' },
        //                     { type: 'Label Editor', os: 'OS', version: 'sssss', file: 'dddd', desc: 'ssss' },
        //                     { type: 'Label Editor', os: 'OS', version: 'sssss', file: 'dddd', desc: 'ssss' },
        //     ],
        // },
        //             {
        //                 model: 'LPQ800',
        //                 image: require('@/assets/images/N41.jpg'),
        //                 checked: false,
        //                 detail: [
        //                     { type: 'Label Editor', os: 'OS', version: 'sssss', file: 'dddd', desc: 'LPQ800' },
        //                     { type: 'Label Editor', os: 'OS', version: 'sssss', file: 'dddd', desc: 'ssss' },
        //                     { type: 'Label Editor', os: 'OS', version: 'sssss', file: 'dddd', desc: 'ssss' },
        //                     { type: 'Label Editor', os: 'OS', version: 'sssss', file: 'dddd', desc: 'ssss' },
        //                     { type: 'Label Editor', os: 'OS', version: 'sssss', file: 'dddd', desc: 'ssss' },
        //                     { type: 'Label Editor', os: 'OS', version: 'sssss', file: 'dddd', desc: 'ssss' },
        //                     { type: 'Label Editor', os: 'OS', version: 'sssss', file: 'dddd', desc: 'ssss' },
        //                     { type: 'Label Editor', os: 'OS', version: 'sssss', file: 'dddd', desc: 'ssss' },
        //                     { type: 'Label Editor', os: 'OS', version: 'sssss', file: 'dddd', desc: 'ssss' },
        //     ],
        // },
        ],
    }
},
methods: {
    btnChoose(e) {
        if (e.target.value) {
            this.model = e.target.value
            this.detail = this.list.find(item => item.model == this.model).detail
        } else {
            this.detail = null
        }
    },
    btnChooseImg(val) {
        this.list.forEach((item, index) => {
            item.checked = index == val ? true : false
        })
    },
},
}
</script>